var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91681 17C6.96109 16.1504 6.06159 15.4008 5.21831 14.5013C4.31882 13.5517 3.53175 12.5522 2.80091 11.5528C1.78898 10.1535 1.11436 8.60424 1.00192 6.95508C0.945699 4.75619 2.12629 3.05705 4.43125 1.85766C7.07353 0.508337 10.3904 0.758211 12.7516 2.5573C14.4382 3.85664 15.2252 5.45584 14.9441 7.40485C14.663 9.45381 13.6511 11.2029 12.2456 12.9021C11.1213 14.3014 9.82824 15.6007 8.31034 16.7501C8.25412 16.8001 8.14168 16.8501 7.91681 17Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50065 4.42859C4.50065 4.42859 4.94692 4.56131 4.72379 6.37513C4.5899 7.39264 6.19648 6.81753 6.68737 8.14472C7.17827 9.42767 6.33036 10.1355 5.70558 11.2857",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4C6 4 8.6256 7.76419 11.5 5",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5C9 11.5 9.45421 7.08998 12.5 8.00003",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6361 7.479C12.6361 9.72128 10.5851 11.6313 7.93474 11.6313C5.28435 11.6313 3.2334 9.72128 3.2334 7.479C3.2334 5.23671 5.28435 3.32666 7.93474 3.32666C10.5851 3.32666 12.6361 5.23671 12.6361 7.479Z",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.3a18679b.svg";
export { ForwardRef as ReactComponent };